<template>
  <div class="card m-0">
    <div class="card-content">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            class="form form-horizontal"
            @submit.prevent="handleSubmit(submitForm)"
          >
            <div class="form-body">
              <div class="row">
                <div class="col-12" v-if="errorMessage.trim() !== ''">
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="alert alert-danger">
                        {{ errorMessage.trim() }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="discount"
                        >Kurs <span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="col-md-9">
                      <ValidationProvider
                        name="Kurs"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="position-relative has-icon-left">
                          <multiselect
                            v-model="course"
                            :options="courses"
                            :multiple="false"
                            label="name"
                            track-by="id"
                            :placeholder="'Kursni tanlang'"
                          />
                        </div>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="discount"
                        >Chegirma (%) <span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="col-md-9">
                      <ValidationProvider
                        name="Chegirma"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="position-relative has-icon-left">
                          <input
                            type="number"
                            id="discount"
                            class="form-control"
                            placeholder="Chegirma (%)"
                            v-model="discount.discount"
                          />
                        </div>
                        <span class="text-danger" v-if="errors.length > 0">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="beginDate"
                        >Chegirmalar boshlanish vaqti<span class="text-danger"
                          >*</span
                        ></label
                      >
                    </div>
                    <div class="col-md-9">
                      <ValidationProvider
                        name="chegirmalar boshlanish vaqti"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="position-relative has-icon-left">
                          <datepicker
                            id="beginDate"
                            placeholder="Chegirmalar boshlanish vaqti"
                            v-model="discount.beginDate"
                          />
                        </div>
                        <span class="text-danger" v-if="errors.length > 0">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="endDate"
                        >Chegirmalar tugash vaqti<span class="text-danger"
                          >*</span
                        ></label
                      >
                    </div>
                    <div class="col-md-9">
                      <ValidationProvider
                        name="Chegirmalar tugash vaqti"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="position-relative has-icon-left">
                          <datepicker
                            id="endDate"
                            placeholder="Chegirmalar tugash vaqti"
                            v-model="discount.endDate"
                          />
                        </div>
                        <span class="text-danger" v-if="errors.length > 0">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-md-3">
                      <label for="description">Chegirma tavsiflari</label>
                    </div>
                    <div class="col-md-9">
                      <div class="position-relative has-icon-left">
                        <textarea
                          type="text"
                          id="description"
                          class="form-control"
                          placeholder="Chegirma tavsiflari"
                          v-model.trim="discount.description"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group row mb-0">
                    <div class="col d-flex justify-content-end">
                      <button
                        type="submit"
                        class="btn btn-info waves-effect waves-light mr-1"
                        :disabled="loading"
                        v-if="successMessage === ''"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          v-if="loading"
                        />
                        {{ update ? "Yangilash" : "Saqlash" }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-success mr-1"
                        disabled="disabled"
                        v-if="successMessage !== ''"
                      >
                        <i class="feather icon-check" />
                        {{ successMessage }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-info waves-effect waves-light"
                        v-if="successMessage === ''"
                        :disabled="loading"
                        @click="closeModal"
                      >
                        Bekor qilish
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Kiriting {_field_}",
});

export default {
  name: "DiscountForm",
  props: {
    discount: Object,
  },
  components: {
    Datepicker,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      courses: [],
      course: null,
      errorMessage: "",
      loading: false,
      successMessage: "",
    };
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.update ? this.updateDiscount() : this.storeDiscount();
    },
    storeDiscount() {
      this.$api
        .post("admin/Tariff/DiscountInsert", this.discountFormData())
        .then((res) => {
          if (!res.error && res.result.success) {
            this.succMessage("Сохранено");
          } else {
            this.errMessage(res.error);
          }
        })
        .catch((err) => {
          this.errMessage("Ошибка");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateDiscount() {
      this.$api
        .put("admin/Tariff/DiscountEdit", this.discountFormData())
        .then((res) => {
          if (!res.error && res.result.success) {
            this.succMessage("Обновлено");
          } else {
            this.errMessage(res.error);
          }
        })
        .catch((err) => {
          this.errMessage("Ошибка");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    discountFormData() {
      this.discount.beginDate = this.$moment(this.discount.beginDate).format(
        "MM.DD.YYYY"
      );
      this.discount.endDate = this.$moment(this.discount.endDate).format(
        "MM.DD.YYYY"
      );
      let form = new FormData();
      for (let prop in this.discount) form.append(prop, this.discount[prop]);

      return form;
    },
    getCourses() {
      this.$api.get("admin/List/GetAllCourseByToken").then((res) => {
        if (!res.error) {
          this.courses = res.result;

          if (this.update) {
            this.course = this.courses.find(
              (item) => item.id === this.discount.courseId
            );
          }
        }
      });
    },
    errMessage(errorMessage) {
      this.errorMessage = errorMessage;
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    },
    succMessage(successMessage) {
      this.successMessage = successMessage;
      setTimeout(() => {
        this.closeModal();
        this.$emit("saved");
      }, 1000);
    },
  },
  watch: {
    course() {
      if (this.isEmptyObject(this.course))
        this.discount.courseId = this.course.id;
    },
  },
  computed: {
    update() {
      return this.discount.id !== 0;
    },
  },
  created() {
    this.getCourses();
  },
  mounted() {
    const datePicker = $(".vdp-datepicker");
    datePicker.addClass("flex-1");
    const inp = $('[readonly="readonly"]');
    inp.addClass("form-control");
    inp.attr("placeholder", "День / Месяц / Год");
  },
};
</script>

<style scoped></style>
